export default __webpack_public_path__ + "static/media/Logo-1-1.f74efbe7.png";